<template>
  <!--搜索栏-->
  <div class="search-bar">
    <van-search
        left-icon=""
        show-action
        v-model="searchText"
        placeholder="输入题名 / 作者 / 出版社 / ISBN"
        background="transparent"
        @search="onSearch">
      <template #action>
        <span @click="advancedSearch">高级搜索</span>
      </template>
    </van-search>
  </div>
  <!-- 筛选-->
  <FilterHeader ref="filterHeader"
                :total="total"
                :facet-list="facetList"
                :showFilterParams="showFilterParams"
                :showFilterButton="showFilterButton"
                @deleteFilterParams="deleteFilterParams"
                @getFilterParams="getFilterParams"/>
  <!--图书列表-->
  <BookBlock :list="books" @onLoad="onLoad" ref="bookChild"/>
</template>

<script>
import {defineComponent, ref, computed, watch, onMounted} from 'vue';
import BookBlock from './BookBlock';
import {FilterHeader} from '../components/common';
import {Toast} from 'vant';
import store from '@/store';
import router from '../router';
import {searchSimple, search} from '@/api/books';
import {SEARCH_ADVANCED, SEARCH_NORMAL} from '@/utils/consts';
import {isNotEmpty, setCovers} from '@/utils/util';

export default defineComponent({
  name: 'SearchResults',
  components: {
    BookBlock,
    FilterHeader
  },
  setup() {
    // 基础检索
    const searchText = ref(''); // 检索词
    const books = ref([]);
    const total = ref(0);
    let page = 1;
    const bookChild = ref();
    const showFilterButton = ref(true);
    const facetList = ref([]);
    // 过滤值
    const showFilterParams = ref([]);
    let filterParams = null;
    const filterHeader = ref();
    // 检索词
    const searchValueParam = computed(() => {
      return store.state.search.searchParams;
    });

    // 普通搜索点击事件
    const onSearch = () => {
      filterHeader.value?.resetPop(); // 清空筛选条件的选择
      if (isNotEmpty(searchText.value)) {
        const params = {
          type: SEARCH_NORMAL,
          param: {query: searchText.value}
        };
        store.commit('search', params);
      } else {
        Toast({message: '请输入搜索词'})
      }
    };

    // 普通搜索
    const onSearchSimple = () => {
      let params = filterParams ? new URLSearchParams(filterParams) : new URLSearchParams();
      params.append('query', searchValueParam.value.param.query);
      params.append('page', page);
      params.append('pageSize', '10');

      searchSimple(params)
          .then(data => {
            if (data) {
              onSearchCommon(data);
              facetList.value = data.facetList ?? [];
            }
            onSearchData();
          })
          .catch((error) => {
            console.error(error);
          });
    };
    const onLoad = () => {
      if (books.value.length < total.value) {
        if (searchValueParam.value.type === SEARCH_NORMAL) {
          onSearchSimple();
        } else if (searchValueParam.value.type === SEARCH_ADVANCED) {
          searchValueParam.value.param.page = searchValueParam.value.param.page + 1;
          onAdvancedSearch();
        }
      } else {
        bookChild.value.loading = false; // 加载状态结束
        bookChild.value.finished = books.value.length >= total.value;
      }
    };
    // 高级搜索点击事件
    const advancedSearch = () => {
      router.push({path: '/advancedSearch'})
    };
    // 高级搜索
    const onAdvancedSearch = () => {
      search(searchValueParam.value.param)
          .then(data => {
            if (data) {
              onSearchCommon(data);
            }
            onSearchData();
          })
          .catch((error) => {
            console.error(error);
          });
    };
    // 对搜索数据的通用处理
    const onSearchCommon = (data) => {
      total.value = data.total;
      if (isNotEmpty(data.dataList)) {
        const isbns = [];
        data.dataList.forEach(item => {
          if (isNotEmpty(item.isbn)) {
            isbns.push(item.isbn);
          }
        });
        setCovers(isbns, data.dataList, 0);
        books.value = books.value.concat(data.dataList);
      }
      page++;
    };
    // 对搜索数据的通用处理
    const onSearchData = () => {
      if (isNotEmpty(bookChild.value)) {
        bookChild.value.loading = false; // 加载状态结束
        bookChild.value.finished = books.value.length >= total.value;
      }
    };

    // 处理过滤条件
    const getFilterParams = (params, showParams) => {
      filterParams = params;
      showFilterParams.value = showParams;
      page = 1;
      books.value = [];
      onSearchSimple();
    }
    // 删除过滤条件
    const deleteFilterParams = (key) => {
      showFilterParams.value = showFilterParams.value.filter(item => item.code !== key);
      if (key === 'yearStartEnd') {
        filterParams.delete('startPublicationYear');
        filterParams.delete('endPublicationYear');
      } else {
        filterParams.delete(key);
      }
      if (showFilterParams.value.length === 0) {
        filterHeader.value?.resetPop(); // 清空筛选条件的选择
      }
      page = 1;
      books.value = [];
      onSearchSimple();
    }
    watch(
        searchValueParam, () => {
          showFilterParams.value = [];
          filterParams = null;
          books.value = [];
          page = 1;
          if (searchValueParam.value.type === SEARCH_NORMAL) {
            // 普通搜索
            showFilterButton.value = true;
            onSearchSimple();
          } else if (searchValueParam.value.type === SEARCH_ADVANCED) {
            // 高级搜索
						searchText.value = '';
            showFilterButton.value = false; // 高级检索不筛选
            onAdvancedSearch();
          }
        },
        {immediate: true}
    );

    onMounted(() => {
      if (searchValueParam.value && searchValueParam.value.type === SEARCH_NORMAL) {
        searchText.value = searchValueParam.value.param.query;
      }
    });
    return {
      onSearch,
      advancedSearch,
      searchValueParam,
      searchText,
      filterHeader,
      books,
      total,
      onLoad,
      bookChild,
      showFilterButton,
      facetList,
      getFilterParams,
      showFilterParams,
      deleteFilterParams
    }
  },
});
</script>

<style scoped lang="less">
@import "../assets/css/search-bar.less";
</style>
